export default class LazyIframeComponent {
  static init($lazyIframe) {
    if (!$lazyIframe || $lazyIframe.lazyIframeComponent) {
      return;
    }

    $lazyIframe.lazyIframeComponent = new LazyIframeComponent($lazyIframe);
  }

  static initAll() {
    document.querySelectorAll('[data-lazy-iframe]').forEach(($lazyIframe) => {
      LazyIframeComponent.init($lazyIframe);
    });
  }

  constructor($lazyIframe) {
    let options = JSON.parse($lazyIframe.dataset.lazyIframe || '{}') || {};

    let defaults = {
      frameborder: '0'
    };

    if (options?.src?.match(/youtube/)) {
      defaults.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      defaults.allowfullscreen = true;

      if (!options.src.match(/autoplay/)) {
        let autoplay = '1';

        if (options.autoplay === false) {
          autoplay = '0';
        }

        if (options.src.indexOf('?') !== -1) {
          options.src += `&autoplay=${autoplay}`;
        } else {
          options.src += `?autoplay=${autoplay}`;
        }
      }

      if (options.src.indexOf('?') !== -1) {
        options.src += '&enablejsapi=1';
      } else {
        options.src += '?enablejsapi=1';
      }
    }

    this.$lazyIframe = $lazyIframe;
    this.options = {...defaults, ...options};
    this.isLoaded = false;

    this.onClick = this.onClick.bind(this);

    this.init();
  }

  init() {
    this.$lazyIframe.addEventListener('click', this.onClick);
  }

  destroy() {
    this.$lazyIframe.removeEventListener('click', this.onClick);
    this.$lazyIframe.lazyIframeComponent = null;
  }

  onClick() {
    this.load();
    this.$lazyIframe.removeEventListener('click', this.onClick);
  }

  load() {
    if (this.isLoaded) {
      return;
    }

    let $iframe = document.createElement('iframe');

    for (let property in this.options) {
      if (this.options.hasOwnProperty(property)) {
        let value = this.options[property];

        $iframe.setAttribute(property, value);
      }
    }

    this.$lazyIframe.innerHTML = '';
    this.$lazyIframe.appendChild($iframe);
    this.$lazyIframe.classList.add('is-loaded');
    this.isLoaded = true;
  }
}
